/**
 * API client for HQ -> New Joiners (staff onboarding tracker).
 *
 * Backend: oh_operations Django app, alfred-suffixed endpoints under
 * /api/v1/oh_operations/new_joiners/. Every `apiEndpoints.X` reference lives
 * INSIDE a function body (TDZ-safety — mirrors parentOnboarding.js).
 */
import { sentryLogger } from 'sentry'

import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get, patch, post, remove } from '../request'

// {roles, steps, centres, joiners}
const fetchNewJoiners = async (role) => {
  try {
    const response = await get(
      makeRequestUrl(`${apiEndpoints.newJoiners}/alfred`, role ? { role } : {})
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching new joiners')
    throw error
  }
}

// {name, role, centre, joining_date} -> the new joiner row
const createNewJoiner = async (body) => {
  try {
    const response = await post(`${apiEndpoints.newJoiners}/alfred`, body)
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in creating new joiner')
    throw error
  }
}

// Edit details and/or set one step: {step, status}
const updateNewJoiner = async (uuid, body) => {
  try {
    const response = await patch(
      `${apiEndpoints.newJoiners}/${uuid}/alfred`,
      body
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in updating new joiner')
    throw error
  }
}

const deleteNewJoiner = async (uuid) => {
  try {
    await remove(`${apiEndpoints.newJoiners}/${uuid}/alfred`)
  } catch (error) {
    sentryLogger(error, 'error in deleting new joiner')
    throw error
  }
}

export { fetchNewJoiners, createNewJoiner, updateNewJoiner, deleteNewJoiner }
